export const LIKES_YOU_Z_INDICES = {
  ACTIVE_REC_CARD: 'Z(2)',
  CLICK_TO_ACTION_BUTTON: 'Z(3)',
  NAV: 'Z(3)--s',
  PROFILE_CARD: 'Z(3)',
};

export const SWIPE_INTERVAL = 250;

// tabs
export const MY_LIKES_TAB = 'myLikes';
export const GOLD_HOME_TAB = 'goldHome';
export const LIKES_YOU_TAB = 'likesYou';

// Pixel interval at which to check for card deloading
export const SCROLL_DELOAD_INTERVAL = 10000;
export const MY_LIKES_UPSELL_COUNT = 3;
export const BOOST_UPSELL_LIKES_YOU_COUNT = 4;

// grid config
const DESKTOP_CARD_WIDTH = 244;
const TABLET_CARD_WIDTH = 160;
const MOBILE_CARD_WIDTH = 46;

type LikesYouGridConfig = {
  itemWidth: number;
  itemHeight: number;
  gridPadding: number;
  gutter: number;
  padding: number;
  units: string;
  minRecDisplayCount: number;
};

type LikesYouConfig = {
  Desktop: LikesYouGridConfig;
  Mobile: LikesYouGridConfig;
  Tablet: LikesYouGridConfig;
};

export const GRID_CONFIG: LikesYouConfig = {
  Desktop: {
    itemWidth: DESKTOP_CARD_WIDTH,
    itemHeight: DESKTOP_CARD_WIDTH * 1.25,
    gridPadding: 130,
    gutter: 10,
    padding: 27,
    units: 'px',
    minRecDisplayCount: 12,
  },
  Tablet: {
    itemWidth: TABLET_CARD_WIDTH,
    itemHeight: TABLET_CARD_WIDTH * 1.25,
    gridPadding: 130,
    gutter: 8,
    padding: 10,
    units: 'px',
    minRecDisplayCount: 12,
  },
  Mobile: {
    itemWidth: MOBILE_CARD_WIDTH,
    itemHeight: MOBILE_CARD_WIDTH * 1.25,
    gridPadding: 40,
    gutter: 2.5,
    padding: 2.5,
    units: 'vw',
    minRecDisplayCount: 9,
  },
};
